module.exports = __webpack_public_path__ + "static/media/HazenLogo.7694d2f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/HazenLogo.svg
// module id = 1141
// module chunks = 0